// Single source of truth for dental-condition colours + labels, shared by the odontogram
// (Odontogram.jsx) and the scan-markup overlay (ScanMarkup.jsx) so a tooth charted red on the
// chart and a finding marked on an X-ray always read the same. FDI conditions match
// ToothChartEntry::CONDITIONS on the backend.

// Tailwind class map — used by the odontogram tooth buttons + legend chips.
export const CONDITION_STYLE = {
  healthy:            'bg-white text-brand-ink border-brand-border',
  caries:             'bg-red-100 text-red-800 border-red-300',
  filling:            'bg-blue-100 text-blue-800 border-blue-300',
  crown:              'bg-amber-100 text-amber-800 border-amber-300',
  bridge:             'bg-amber-100 text-amber-800 border-amber-300',
  root_canal:         'bg-purple-100 text-purple-800 border-purple-300',
  implant:            'bg-teal-100 text-teal-800 border-teal-300',
  missing:            'bg-gray-200 text-gray-400 border-gray-300 line-through',
  extraction_planned: 'bg-orange-100 text-orange-800 border-orange-300',
  fracture:           'bg-pink-100 text-pink-800 border-pink-300',
  // Patient dental-chart overlay (Paul): red = work outstanding, black = done / existing.
  needs_work:         'bg-red-500 text-white border-red-700',
  done:               'bg-gray-800 text-white border-gray-900',
}

export const LABELS = {
  healthy: 'Healthy', caries: 'Caries', filling: 'Filling', crown: 'Crown', bridge: 'Bridge',
  root_canal: 'Root canal', implant: 'Implant', missing: 'Missing',
  extraction_planned: 'Extraction planned', fracture: 'Fracture',
  needs_work: 'Needs work', done: 'Done / existing',
}

// Hex map — used for SVG/canvas strokes + fills on the scan overlay (Tailwind classes can't be
// applied to raw SVG geometry). Kept visually in step with CONDITION_STYLE above.
export const CONDITION_HEX = {
  healthy:            '#94a3b8',
  caries:             '#dc2626',
  filling:            '#2563eb',
  crown:              '#d97706',
  bridge:             '#d97706',
  root_canal:         '#7c3aed',
  implant:            '#0d9488',
  missing:            '#9ca3af',
  extraction_planned: '#ea580c',
  fracture:           '#db2777',
  needs_work:         '#ef4444',
  done:               '#1f2937',
}

export const hexFor = (condition) => CONDITION_HEX[condition] || CONDITION_HEX.healthy
export const labelFor = (condition) => LABELS[condition] || condition
